// removed by extract-text-webpack-plugin
module.exports = {"checkbox-container":"DesktopQuestionCell__checkbox-container___1N2W5"};